import React from 'react';
import blogPosts from '../../data/blogPosts.json';
import researchPapers from '../../data/researchPapers';
import { getPublishedPosts } from './publishedPosts';
import styles from './WritingSection.module.css';

export default function WritingSection({ posts = blogPosts }) {
  const published = getPublishedPosts(posts);

  return (
    <section id="writing" className={styles.section} aria-labelledby="writing-title">
      <div className="section-heading">
        <h2 id="writing-title">Research &amp; Writing</h2>
        <p>
          Research papers and technical write-ups on robotics, machine learning, and systems.
        </p>
      </div>

      <ul className={styles.list}>
        {published.map((post) => (
          <li key={post.slug}>
            <h3>
              <a href={`/blog/${post.slug}/`}>{post.title}</a>
            </h3>
            <p className={styles.meta}>
              {post.category}
              {post.date ? ` · ${post.date}` : ''}
              {post.read_time ? ` · ${post.read_time}` : ''}
            </p>
          </li>
        ))}
        {researchPapers.map((paper) => (
          <li key={paper.href}>
            <div className={styles.titleBlock}>
              <h3>
                <a href={paper.href}>{paper.title}</a>
              </h3>
              <p className={styles.byline}>{paper.collaborators}</p>
            </div>
            <p className={styles.meta}>UC Berkeley · 2024 · PDF</p>
          </li>
        ))}
      </ul>

      <p className={styles.visit}>
        <a href="/blog/">All writing</a>
      </p>
    </section>
  );
}
